<div class="icon">
  <img src="assets/icons/UnsupportedPC.svg">
</div>
<div class="content">
  {{ compatabilityStatement }}
</div>
